import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'app-total-table',
    template: `
      <div style="display: flex; flex-direction: row; width: 100%">
        <div class="text-left label-maps" style="min-width: 220px" *ngIf="totalRegistros && showRegistersPerPage">
            Mostrando
            <mat-form-field style="display: inline-block; position: relative; width: 56px">
                <mat-select (selectionChange)="onChangeTotalPorPagina($event.value)" [value]="totalPorPagina">
                    <mat-option *ngFor="let opcao of opcoesPorPagina" [value]="opcao">{{ opcao }}</mat-option>
                </mat-select>
            </mat-form-field> por página
        </div>
        <div style="min-width: 200px; padding-top:10px">
          <mat-chip-list *ngIf="(totalSelecionados$ | async) > 0">
            <mat-chip *ngIf="(totalSelecionados$ | async) == 1">{{ totalSelecionados$ | async }} item selecionado</mat-chip>
            <mat-chip *ngIf="(totalSelecionados$ | async) > 1">{{ totalSelecionados$ | async }} itens selecionados</mat-chip>
          </mat-chip-list>
        </div>
        <div class="text-right label-maps" *ngIf="totalRegistros !== null" style="padding-top: 23px; width: 100%">
          <p>Total de registro(s) encontrado(s): <strong>{{this.totalRegistros}}</strong></p>
        </div>
     </div>
    `,
})
export class TotalTableComponent implements OnInit {

  @Input() public totalRegistros: number;
  @Input() public totalPorPagina = 20;
  @Input() public totalSelecionados$: BehaviorSubject<number>;
  @Output() public onChange = new EventEmitter();
  @Input() showRegistersPerPage = true;
  public opcoesPorPagina: number[] = [5, 10, 15, 20, 25, 50];

  constructor() {
  }

  ngOnInit() {
  }

  onChangeTotalPorPagina(e) {
    this.totalPorPagina = e;
    this.onChange.emit(e);
  }

}
